import { basePath } from './constants'

interface UpdateSheetParams {
  sheetId: string
  token: string
  rules?: any[]
  name?: string
  fields?: any
  enrichments?: any
}

/**
 * Updates a sheet with new transformation rules or other data
 * @param params - The parameters for updating the sheet
 * @returns Promise containing the updated sheet
 * @throws Error if the request fails
 */
export async function updateSheet({
  sheetId,
  token,
  rules,
  name,
  fields,
  enrichments,
}: UpdateSheetParams): Promise<any> {
  try {
    const body: any = {}

    if (rules !== undefined) {
      body.rules = rules
    }
    if (name !== undefined) {
      body.name = name
    }
    if (fields !== undefined) {
      body.fields = fields
    }
    if (enrichments !== undefined) {
      body.enrichments = enrichments
    }

    const response = await fetch(`${basePath}/sheets/${sheetId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    })

    if (!response.ok) {
      throw new Error(`Failed to update sheet: ${response.statusText}`)
    }

    const updatedSheet = await response.json()
    return updatedSheet
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Error updating sheet: ${error.message}`)
    }
    throw new Error('An unknown error occurred while updating the sheet')
  }
}
